import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { I18nModule } from '@recruitee/i18n';
import {
  ButtonComponent,
  DropdownComponent,
  DropdownItemComponent,
  EmptyStateComponent,
  SpinnerComponent,
} from '@recruitee/user-interface';

import { ActivitiesListModule } from '../ui/activities-list/activities-list.module';
import { NotificationListContainerComponent } from './unread-notification-list-container/notification-list-container.component';

@NgModule({
  exports: [NotificationListContainerComponent],
  imports: [
    ActivitiesListModule,
    ButtonComponent,
    CommonModule,
    DropdownComponent,
    DropdownItemComponent,
    EmptyStateComponent,
    I18nModule,
    InfiniteScrollModule,
    SpinnerComponent,
    NotificationListContainerComponent,
  ],
})
export class ActivitiesContainersModule {}

export { NotificationListContainerComponent };
